module.exports = __webpack_public_path__ + "static/img/bg_02.f999601.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/themes/bg_02.jpg
// module id = 5l1U
// module chunks = 29